<span class="inline-flex items-center justify-between">
    <span class="pr-1">
        <ng-content></ng-content>
    </span>
    <mat-icon
        class="text-primary cursor-pointer guidance-icon"
        (click)="onContextualizeGuidance()"
        [matTooltip]="tooltip"
    >
        help
    </mat-icon>
</span>
